/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misty_Proof_Okapi_NourishInputs */

const fr_misty_proof_okapi_nourish = /** @type {(inputs: Misty_Proof_Okapi_NourishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date anniversaire`)
};

/**

* @param {Misty_Proof_Okapi_NourishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const misty_proof_okapi_nourish = /** @type {((inputs?: Misty_Proof_Okapi_NourishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misty_Proof_Okapi_NourishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_misty_proof_okapi_nourish(inputs)
});